import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, catchError,  withLatestFrom, switchMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { EventSystemActions, EventSystemApiActions } from '../actions/event-system.actions';
import { EventSystemsService } from '../../event-systems.service';
import { EventSystemComplete } from '../../models/event-systems/event-system-complete.model';
import { selectAllEventSystems, selectEventSystem } from '../selectors/event-systems.selectors';
import { concatLatestFrom } from '@ngrx/operators';

@Injectable()
export class EventSystemEffects {
    private action$ = inject(Actions);
    private service = inject(EventSystemsService);
    private store = inject(Store);

    loadFullEventSystems$ = createEffect(() => {
        return this.action$.pipe(
            ofType(EventSystemActions.loadEventSystems),
            withLatestFrom(this.store.select(selectAllEventSystems)),
            switchMap(([action],data) => {
                if (data){
                    return of();
                }
                else{
                    return this.service.getEventSystems().pipe(
                        map(data => (EventSystemApiActions.retrieveListOfEventSystems({ eventSystems: data})))
                    )
                }
            })
        )
    })

    loadSingleEventSystem$ = createEffect(() => {
        return this.action$.pipe(
            ofType(EventSystemActions.getSingleEventSystem),
            concatLatestFrom(action => this.store.select(selectEventSystem(action.systemRef))),
            switchMap(([action,result]) => {
                if (result){
                    return of()
                }
                else{
                    return this.service.getEventSystem(action.systemRef).pipe(
                        map(data => (EventSystemApiActions.fetchSingleEventSystem({ eventSystem: data as EventSystemComplete}))),
                        catchError(() => of())
                    )
                }
            })
        )
    })
}